const autoTypes = [
  {
    questionId: 1761137,
    answerId: "ACCEPT_ANY", // `id` or 'ACCEPT_ANY'
    // valueToInsert: "", // (answerLabel) => answerLabel
  },
  { questionId: 1814395, answerId: "ACCEPT_ANY" },
  { questionId: 1761142, answerId: "ACCEPT_ANY" },
  { questionId: 1761139, answerId: "ACCEPT_ANY" },
  { questionId: 1761171, answerId: "ACCEPT_ANY" },
  { questionId: 1761177, answerId: "ACCEPT_ANY" },
  { questionId: 1814396, answerId: "ACCEPT_ANY" },

  {
    questionId: 1761172,
    answerId: 6925620,
    valueToInsert: "با قصد مهاجرت تحصیلی و کاری",
  },
  {
    questionId: 1761172,
    answerId: 6925619,
    valueToInsert: "با قصد مهاجرت کاری",
  },
  {
    questionId: 1761172,
    answerId: 7279468,
    valueToInsert: "با قصد مهاجرت کاری",
  },
  {
    questionId: 1761172,
    answerId: 7610723,
    valueToInsert: "با قصد مهاجرت برای زندگی",
  },
  {
    questionId: 1761172,
    answerId: 7108949,
    valueToInsert: "با قصد مهاجرت به هر روشی",
  },
  {
    questionId: 1761172,
    answerId: 7625444,
    valueToInsert: "مهاجرت کرده",
  },

  {
    questionId: 1761175,
    answerId: 6925638,
    valueToInsert: "دارای بیماری خاص",
  },

  {
    questionId: 1761175,
    answerId: 7113646,
    valueToInsert: "دارای معلولیت",
  },

  // سوگ از دست دادن عزیزان
  {
    questionId: 1870774,
    answerId: 7113646,
    valueToInsert: "دارای معلولیت",
  },

  // پرتنش ترین
  {
    questionId: 1843003,
    answerId: 7202128,
    valueToInsert: "ناراضی از رابطه با پدر",
  },
  {
    questionId: 1843003,
    answerId: 7202129,
    valueToInsert: "ناراضی از رابطه با مادر",
  },
  {
    questionId: 1843003,
    answerId: 7202130,
    valueToInsert: "ناراضی از رابطه با همسر",
  },
  {
    questionId: 1843003,
    answerId: 7240997,
    valueToInsert: "ناراضی از رابطه با پارتنر",
  },
  {
    questionId: 1843003,
    answerId: 7202133,
    valueToInsert: "ناراضی از رابطه با خواهر و برادر",
  },
  {
    questionId: 1843003,
    answerId: 7240998,
    valueToInsert: "ناراضی از رابطه با خانواده",
  },
  {
    questionId: 1843003,
    answerId: 7202132,
    valueToInsert: "ناراضی از رابطه با خانواده همسر",
  },

  {
    questionId: 1761225,
    answerId: 6925904,
    valueToInsert: "بی علاقه به شغل",
  },

  {
    questionId: 1865838,
    answerId: 7282049,
    valueToInsert: "دارای نوجوان",
  },
  {
    questionId: 1865838,
    answerId: 7282048,
    valueToInsert: "دارای کودک",
  },
  {
    questionId: 1865838,
    answerId: 7282047,
    valueToInsert: "دارای خردسال",
  },
  {
    questionId: 1865838,
    answerId: 7282046,
    valueToInsert: "دارای فرزند زیر 3 سال",
  },

  { questionId: 6901, answerId: "ACCEPT_ANY" },
  { questionId: 6950, answerId: "ACCEPT_ANY" },
  { questionId: 6953, answerId: "ACCEPT_ANY" },
  { questionId: 6951, answerId: "ACCEPT_ANY" },
  { questionId: 6955, answerId: "ACCEPT_ANY" },
  { questionId: 7019, answerId: "ACCEPT_ANY" },
  { questionId: 6960, answerId: "ACCEPT_ANY" },

  {
    questionId: 7002,
    answerId: 35724,
    valueToInsert: "مهاجرت کرده",
  },

  {
    questionId: 7017,
    answerId: 35751,
    valueToInsert: "دارای بیماری خاص",
  },
  {
    questionId: 7017,
    answerId: 35752,
    valueToInsert: "دارای معلولیت",
  },

  {
    questionId: 8231,
    answerId: 40744,
    valueToInsert: "بی علاقه به شغل",
  },

  {
    questionId: 8226,
    answerId: 40723,
    valueToInsert: "ناراضی از رابطه با پدر",
  },
  {
    questionId: 8226,
    answerId: 40724,
    valueToInsert: "ناراضی از رابطه با مادر",
  },
  {
    questionId: 8226,
    answerId: 40725,
    valueToInsert: "ناراضی از رابطه با همسر",
  },
  {
    questionId: 8226,
    answerId: 40727,
    valueToInsert: "ناراضی از رابطه با پارتنر",
  },
  {
    questionId: 8226,
    answerId: 40730,
    valueToInsert: "ناراضی از رابطه با خواهر و برادر",
  },
  {
    questionId: 8226,
    answerId: 40728,
    valueToInsert: "ناراضی از رابطه با خانواده",
  },
  {
    questionId: 8226,
    answerId: 40729,
    valueToInsert: "ناراضی از رابطه با خانواده همسر",
  },
];

export default autoTypes;
